<template>
  <div class="number-info-body">
    <div class="number-info-content">
      <div
        class="identity-type"
        :class="{ active: companyType === 1 }"
        @click="companyType = 1"
      >
        <img src="@/assets/img/gou.png" />
        <span>
          <img src="@/assets/img/zhengfu.png" />
        </span>
        <div>
          <p>我是政府组织</p>
          <span
            >如果您是政府机关单位或事业单位，准备在平台上进行场景申报和发榜相关服务。您可以自助登记，客服人员将在24小时内与您联系并完成账号身份的核验查实</span
          >
        </div>
      </div>
      <div
        class="identity-type"
        :class="{ active: companyType === 2 }"
        @click="companyType = 2"
      >
        <img src="@/assets/img/gou.png" />
        <span>
          <img src="@/assets/img/qiye.png" />
        </span>
        <div>
          <p>我是企业单位</p>
          <span>
            如果您是准备以企业身份，准备在平台上参与场景建设的揭榜流程，您可以自助登记，客服人员讲在24小时内与您联系并完成账号身份的核验查实
          </span>
        </div>
      </div>
    </div>
    <div class="number-info-footer">
      <a-button @click="nextStep">下一步</a-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      companyType: 1,
    };
  },
  methods: {
    // 下一步
    nextStep() {
      this.$emit("next", this.companyType);
    },
    // 上一步
    // previous() {
    //   this.$emit("pre");
    // },
  },
};
</script>

<style lang="less" scoped>
.number-info-body {
  height: 100%;
  width: 640px;
  margin: 0 auto;
  padding: 40px 0;
  .number-info-content {
    height: 510px;
    padding-top: 40px;
    .identity-type {
      position: relative;
      display: flex;
      align-items: center;
      background: #fafafa;
      border: 1px solid #f0f0f0;
      border-radius: 2px;
      padding: 30px 40px;
      margin-bottom: 24px;
      cursor: pointer;
      > img {
        position: absolute;
        top: 0;
        left: 0;
        display: none;
      }
      > span {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-right: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(45deg, #08c39e 0%, #17d091 100%);
      }
      > div {
        flex: 1;
        > p {
          font-size: 20px;
          line-height: 20px;
          margin-bottom: 30px;
        }
        > span {
          color: #8c8c8c;
          line-height: 22px;
        }
      }
      &:last-child {
        margin-bottom: 0;
        > span {
          background: linear-gradient(45deg, #2e8bff 0%, #37a3ff 100%);
        }
      }
      &.active {
        border-color: #1abc9c;
        > img {
          display: block;
        }
      }
    }
  }
  .number-info-footer {
    > button {
      display: block;
      width: 100%;
      height: 48px;
      background: #1abc9c;
      border-color: #1abc9c;
      border-radius: 2px;
      font-size: 16px;
      color: #fff;
      margin-bottom: 24px;
    }
    > p {
      display: flex;
      align-items: center;
      justify-content: center;
      > span {
        color: #1abc9c;
        cursor: pointer;
      }
    }
  }
}
</style>
